import type { AffiliateStockListing, CapiProductPage } from 'types/capi/pdp';
import { fromProductDetailPage } from 'types/TrackableProduct';

import RetailerInteractionEvent from '~/events/RetailerInteractionEvent';
import usePageData from '~/hooks/usePageData';
import useRootData from '~/hooks/useRootData';
import {
  getSortedStockListingsForSize,
  toRetailerOption
} from '~/utils/listings';

type FireOptions = {
  listing: AffiliateStockListing;
  selectedSize?: string;
};

export default function useRetailerInteraction() {
  const { isBot } = useRootData();
  const page = usePageData<CapiProductPage>();

  return ({ listing, selectedSize }: FireOptions) => {
    const retailers = getSortedStockListingsForSize(page, selectedSize).map(
      (option, index) => toRetailerOption(option, index, selectedSize)
    );

    return new RetailerInteractionEvent({
      isBot,
      product: fromProductDetailPage(page),
      retailerId: listing.affiliate.canonical_id,
      retailers,
      selectedSize
    }).send();
  };
}
